// // Logging setup
const log = message => console.log(message);

const WebSocketStatus = {
    NOT_CONNECTED: 1,

    SUBSCRIPTION_REGISTRATION_STARTED: 2,

    SUBSCRIPTION_REGISTERED: 3,
};

class GraphQLSubscriptionClient {
    constructor(endpoint, authToken) {
        this.endpoint = endpoint.replace('https', 'wss').replace('appsync-api', 'appsync-realtime-api');
        this.authToken = authToken;
        this.headers = {
            Env: process.env.VUE_APP_ENV_LABEL,
            Authorization: `Bearer ${authToken}`,
            host: endpoint.replace('https://', '').replace('/graphql', ''),
        };

        this.websocket = null;
        this.websocketStatus = WebSocketStatus.NOT_CONNECTED;
        this.subscribePayload = null;
        this.subscriptionId = null;
    }

    onOpen() {
        const initMessage = { type: 'connection_init' };
        this.websocket.send(JSON.stringify(initMessage));
    }

    onMessage(data) {
        const message = JSON.parse(data.data);
        const messageType = message.type;
        if (messageType === 'connection_ack') {
            const registerMessage = {
                id: this.subscriptionId,
                type: 'start',
                payload: {
                    data: JSON.stringify(this.subscribePayload),
                    extensions: { authorization: this.headers },
                },
            };
            this.websocket.send(JSON.stringify(registerMessage));
        } else if (messageType === 'start_ack') {
            this.websocketStatus = WebSocketStatus.SUBSCRIPTION_REGISTERED;
        } else if (messageType === 'data') {
            this.onMessageCallback(message);
        } else if (messageType === 'connection_error') {
            log(`[onMessage] Error: ${JSON.stringify(message.payload)}`);
        }
    }

    onError = error => {
        log(`[onError] WebSocket error: ${error}`);
    }

    onClose() {
        this.websocket = null;
        this.websocketStatus = WebSocketStatus.NOT_CONNECTED;
    }

    subscribe(query, operationName, variables = {}, onMessageCallback) {
        if (this.websocketStatus !== WebSocketStatus.NOT_CONNECTED) {
            this.unsubscribe();
        }

        this.onMessageCallback = onMessageCallback;
        this.subscribePayload = { query, operationName, variables };
        this.subscriptionId = crypto.randomUUID();

        const encodedHeaders = btoa(JSON.stringify(this.headers));
        const websocketUrl = `${this.endpoint}?header=${encodedHeaders}&payload=e30=`;
        this.websocket = new WebSocket(websocketUrl, ['graphql-ws']);

        this.websocket.addEventListener('open', this.onOpen.bind(this));
        this.websocket.addEventListener('message', this.onMessage.bind(this));
        this.websocket.addEventListener('error', this.onError.bind(this));
        this.websocket.addEventListener('close', this.onClose.bind(this));

        this.websocketStatus = WebSocketStatus.SUBSCRIPTION_REGISTRATION_STARTED;
    }

    unsubscribe() {
        if (!this.websocket || this.websocketStatus === WebSocketStatus.NOT_CONNECTED) {
            return;
        }

        const deregisterMessage = { type: 'stop', id: this.subscriptionId };
        this.websocket.send(JSON.stringify(deregisterMessage));
        this.websocket.close();
        this.websocket = null;
        this.websocketStatus = WebSocketStatus.NOT_CONNECTED;
    }
}
module.exports = GraphQLSubscriptionClient;
